/**
 * Formeya desktop — Horizon header-menu hover düzeltmeleri:
 * 1) pointerenter auf <a> → parent <li>
 * 2) Kardeş menüleri kapat (eski panel «aktif» kalmasın)
 */
(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)')

  function dispatchEnter(li, event) {
    li.dispatchEvent(
      new PointerEvent('pointerenter', {
        bubbles: false,
        cancelable: true,
        clientX: event?.clientX ?? 0,
        clientY: event?.clientY ?? 0,
        pointerId: event?.pointerId ?? 1,
        pointerType: event?.pointerType ?? 'mouse',
      }),
    )
  }

  function deactivateSiblings(activeLi) {
    const list = activeLi.closest('.menu-list')
    if (!list) return
    list.querySelectorAll(':scope > .menu-list__list-item').forEach(function (item) {
      if (item === activeLi) return
      const link = item.querySelector(':scope > .menu-list__link, :scope > a[ref="menuitem"]')
      const submenu = item.querySelector(':scope > .menu-list__submenu')
      link?.setAttribute('aria-expanded', 'false')
      submenu?.removeAttribute('data-active')
    })
  }

  function bindListItem(li) {
    if (li.dataset.fmDeskNav === '1') return
    if (!li.querySelector(':scope > [ref="submenu[]"], :scope > .menu-list__submenu')) return
    li.dataset.fmDeskNav = '1'

    const submenu = li.querySelector(':scope > .menu-list__submenu')
    const links = li.querySelectorAll(':scope > a.menu-list__link, :scope > a[ref="menuitem"]')

    const activate = function (event) {
      if (!DESKTOP_MQ.matches) return
      deactivateSiblings(li)
      if (event.target !== li) dispatchEnter(li, event)
    }

    const keepOpen = function (event) {
      if (!DESKTOP_MQ.matches) return
      deactivateSiblings(li)
      dispatchEnter(li, event)
    }

    li.addEventListener('pointerenter', activate, true)

    links.forEach(function (link) {
      link.addEventListener('pointerenter', activate, true)
      link.addEventListener('focus', activate, true)
    })

    if (submenu) {
      submenu.addEventListener('pointerenter', keepOpen, true)
      submenu.addEventListener('focusin', keepOpen, true)
      const list = li.closest('.menu-list')
      const items = list ? [...list.querySelectorAll(':scope > .menu-list__list-item')] : []
      const idx = items.indexOf(li)
      const isLastTwo = idx >= items.length - 2 && items.length > 2
      if (isLastTwo) {
        submenu.style.setProperty('left', 'auto', 'important')
        submenu.style.setProperty('right', '0', 'important')
        submenu.style.setProperty('transform', 'none', 'important')
      } else {
        submenu.style.setProperty('left', '50%', 'important')
        submenu.style.setProperty('right', 'auto', 'important')
        submenu.style.setProperty('transform', 'translateX(-50%)', 'important')
      }
    }
  }

  function hideEmptyOverflow() {
    document.querySelectorAll('.header-menu overflow-list.overflow-menu').forEach(function (ol) {
      const root = ol.shadowRoot
      if (!root) return
      const overflowSlot = root.querySelector('slot[name="overflow"]')
      const assigned = overflowSlot?.assignedElements?.({ flatten: true }) ?? []
      const moreBtn = root.querySelector('[part="more"] button, li[part="more"] button')
      if (assigned.length === 0 && moreBtn) {
        const moreLi = moreBtn.closest('li')
        if (moreLi) moreLi.hidden = true
      }
    })
  }

  function fixSubmenuOverflow() {
    document.querySelectorAll('.header-menu .menu-list__submenu-inner').forEach(function (el) {
      el.style.setProperty('max-height', 'none', 'important')
      el.style.setProperty('overflow', 'visible', 'important')
      el.style.setProperty('overflow-y', 'visible', 'important')
      el.style.setProperty('height', 'auto', 'important')
      if (el.querySelector('.fm-mega-bettwasche__column')) {
        el.style.setProperty('min-width', '560px', 'important')
        el.style.setProperty('width', 'max-content', 'important')
      } else if (el.querySelector('.fm-mega-compact__column')) {
        el.style.setProperty('min-width', '360px', 'important')
        el.style.setProperty('width', 'max-content', 'important')
      } else if (el.querySelector('.fm-mega-simple__column')) {
        el.style.setProperty('min-width', '200px', 'important')
        el.style.setProperty('max-width', '280px', 'important')
        el.style.setProperty('width', 'max-content', 'important')
      }
    })
  }

  function boot() {
    if (!DESKTOP_MQ.matches) return
    document.querySelectorAll('.header-menu .menu-list__list-item').forEach(bindListItem)
    hideEmptyOverflow()
    fixSubmenuOverflow()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  DESKTOP_MQ.addEventListener('change', boot)
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true })
})()
